/* global axios */
import ApiClient from './ApiClient';

class AddressAPI extends ApiClient {
  constructor() {
    super('addresses', { accountScoped: true });
  }

  getAddresses() {
    return axios.get(
      `${this.apiVersion}/accounts/${this.accountIdFromRoute}/addresses`
    );
  }

  addAddress(data) {
    return axios
      .post(
        `${this.apiVersion}/accounts/${this.accountIdFromRoute}/addresses`,
        data
      )
      .then(response => response.data);
  }

  deactivateAddress(id) {
    return axios.patch(
      `${this.apiVersion}/accounts/${this.accountIdFromRoute}/addresses/${id}/deactivate`
    );
  }

  updateAddress(id, data) {
    return axios.put(
      `${this.apiVersion}/accounts/${this.accountIdFromRoute}/addresses/${id}`,
      data
    );
  }

  // remove method after migrating back from helena
  getAddressesHelena(helenaKey) {
    return axios.get(
      `${this.apiVersion}/accounts/${this.accountIdFromRoute}/addresses?helena_key=${helenaKey}`
    );
  }
}

export default new AddressAPI();
